import { Check, X } from "lucide-react";
import { passwordChecks } from "@/lib/passwordPolicy";

/** Live 4-rule checklist for the shared password complexity policy. */
export default function PasswordRequirements({ password, testId = "password-requirements" }) {
    const c = passwordChecks(password || "");
    return (
        <div className="flex flex-wrap gap-2.5 mt-2 text-[11px]" data-testid={testId}>
            <Rule ok={c.len8}    label="8+ characters" />
            <Rule ok={c.upper}   label="1 uppercase" />
            <Rule ok={c.digit}   label="1 number" />
            <Rule ok={c.special} label="1 special character" />
        </div>
    );
}

function Rule({ ok, label }) {
    return (
        <span className={`inline-flex items-center gap-1 ${ok ? "text-emerald-600 dark:text-emerald-400" : "text-muted-foreground"}`}>
            {ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />} {label}
        </span>
    );
}
